export const envConstants = {
  get ENV() {
    return process.env.ENV;
  },
  get APP_HTTP_PROXY() {
    return process.env.APP_HTTP_PROXY;
  },
  get EPOCH_HOST() {
    return process.env.NEXT_EPOCH_HOST;
  },
  get DEV_MODE() {
    return process.env.DEV_MODE;
  },
  get DISH_POINTER_BASE_URL() {
    return process.env.DISH_POINTER_BASE_URL;
  },
  get DEV_ENV() {
    return process.env.DEV_ENV;
  },
  get AWS_SECRETS_FEATURE_FLAG() {
    return process.env.AWS_SECRETS_FEATURE_FLAG;
  },
  get AWS_SECRETS_REGION() {
    return process.env.AWS_SECRETS_REGION;
  },
  get AWS_SECRETS_PREFIX() {
    return process.env.AWS_SECRETS_PREFIX;
  },
  get EPOCH_ACCESS_TOKEN() {
    return process.env.EPOCH_ACCESS_TOKEN;
  },
  get SB_TIMEOUT_MS() {
    return parseInt(process.env.SB_TIMEOUT || "3000");
  },
  get AEM_TIMEOUT_MS() {
    return parseInt(process.env.AEM_TIMEOUT || "30000");
  },
  get UF_PLIMIT() {
    return parseInt(process.env.UF_PLIMIT || "5");
  },
  get TG_CACHE_INT() {
    return process.env.TG_CACHE_INT;
  },
  get AEM_HOST() {
    return process.env.UF_AEM_CMS_HOST;
  },
  get PCP_SB_ACCESS_TOKEN() {
    return process.env.PCP_SB_ACCESS_TOKEN;
  },
  get USE_ONE_TRUST() {
    return process.env.USE_ONE_TRUST;
  },
  get ONE_TRUST_SCRIPT() {
    return process.env.ONE_TRUST_SCRIPT;
  },
  get ONE_TRUST_DATA_SCRIPT() {
    return process.env.ONE_TRUST_DATA_SCRIPT;
  },
  get EVOLV_ENV() {
    return process.env.EVOLV_ENV;
  },
  get EVOLV_ENABLE_SSR() {
    return process.env.USE_EVOLV_SSR;
  },
  get EVOLV_ENABLE() {
    return process.env.USE_EVOLV;
  },
  get EVOLV_TIMEOUT() {
    return parseInt(process.env.EVOLV_TIMEOUT || "1000");
  },
  get EVOLV_UID() {
    return process.env.EVOLV_UID || "upperfunnel";
  },
  get K8S_ENV_PREFIX() {
    return process.env.K8S_ENV_PREFIX;
  },
  get PLATFORM() {
    return process.env.PLATFORM;
  },
  get USE_STORYBLOK() {
    return process.env.USE_STORYBLOK;
  },
  get SB_PREVIEW_ALLOWED() {
    return process.env.SB_PREVIEW_ALLOWED;
  },
  get SB_DIR_FOLDER() {
    return process.env.SB_DIR_FOLDER;
  },
  get SB_REFERENCE_COMPONENT() {
    return process.env.SB_REFERENCE_COMPONENT;
  },
  get SB_ACCESS_TOKEN() {
    return process.env.SB_ACCESS_TOKEN;
  },
  get UF_CACHE_INT() {
    return parseFloat(process.env.UF_CACHE_INT || "5");
  },
  get HTTP_PROXY() {
    return process.env.HTTP_PROXY;
  },
  get NEXT_ENV() {
    return process.env.NEXT_ENV;
  },
  get SOLR_ENV() {
    return process.env.SOLR_ENV;
  },
  get DTVI_EPOCH_CONTRACT_INDICATOR() {
    return process.env.DTVI_EPOCH_CONTRACT_INDICATOR;
  },
  get DTVS_EPOCH_CONTRACT_INDICATOR() {
    return process.env.DTVS_EPOCH_CONTRACT_INDICATOR;
  },
  get TARGET_ROLE() {
    return process.env.TARGET_ROLE;
  },
  get APP_NAME() {
    return process.env.APP_NAME;
  },
  get NODE_ENV() {
    return process.env.NODE_ENV;
  },
  get PORT() {
    return process.env.PORT;
  },
  get APP_DEV_PROXY() {
    return process.env.APP_DEV_PROXY;
  },
  get NEXT_PUBLIC_LINKED_DTV_ACCT_NUM() {
    return process.env.NEXT_PUBLIC_LINKED_DTV_ACCT_NUM;
  },
  get NEXT_PUBLIC_LINKED_DTVN_ACCT_NUM() {
    return process.env.NEXT_PUBLIC_LINKED_DTVN_ACCT_NUM;
  },
  get NEXT_PUBLIC_UUID() {
    return process.env.NEXT_PUBLIC_UUID;
  },
  get NEXT_PUBLIC_LOGGED_IN_ID() {
    return process.env.NEXT_PUBLIC_LOGGED_IN_ID;
  },
  get NEXT_PUBLIC_SESSION_ID() {
    return process.env.NEXT_PUBLIC_SESSION_ID;
  },
  get NEXT_PUBLIC_AUTHORIZATION() {
    return process.env.NEXT_PUBLIC_AUTHORIZATION;
  },
  get HOST_NAME() {
    return process.env.hostname;
  },
  get YOTPO_APP_KEY(){
    return process.env.YOTPO_APP_KEY;
  },
  get SEARCH_API_KEY() {
    return process.env.SEARCH_API_KEY;
  },
  get SERVICE_ABILITY_AUTH() {
    return process.env.SERVICE_ABILITY_AUTH;
  },
  get VIDEO_SERVICE_AUTH() {
    return process.env.VIDEO_SERVICE_AUTH;
  },

  get DISABLE_PROXY() {
    return process.env.DISABLE_PROXY;
  },
  get AEM_CMS_HOST() {
    return process.env.AEM_CMS_HOST;
  },
  get UF_AEM_CMS_HOST() {
    return process.env.UF_AEM_CMS_HOST;
  },
  get NEXT_EPOCH_HOST() {
    return process.env.NEXT_EPOCH_HOST;
  },
  get SB_TIMEOUT() {
    return process.env.SB_TIMEOUT
  },
  get AEM_TIMEOUT() {
    return process.env.AEM_TIMEOUT
  },
  get BUILD_VERSION() {
    return process.env.BUILD_VERSION;
  },
  get UF_API_CACHE_INT() {
    if(process.env.ENV === "prod"){
      return parseFloat(process.env.UF_API_CACHE_INT || "10");
    }
    return parseFloat(process.env.UF_API_CACHE_INT || "10");
  },
  get STYLE_OVERWRITE_API_URL() {
    if(process.env.ENV === "prod"){
      return process.env.STYLE_OVERWRITE_API_URL || "https://www.directv.com/assets/content/43gso8pg9m/original/style-overwrite";
    }
    return process.env.STYLE_OVERWRITE_API_URL_TEST || "https://www.directv.com/assets/content/kydz69h3md/original/style-overwrite-test";
  },
  get STYLE_OVERWRITE_TIMEOUT_MS() {
    return parseInt(process.env.STYLE_OVERWRITE_TIMEOUT_MS || "10000");
  },
  get STYLE_OVERWRITE_CACHE_INT() {
    return parseInt(process.env.STYLE_OVERWRITE_CACHE_INT || "15"); // minutes
  },

  get COMPONENT_OVERWRITE_API_URL() {
    if(process.env.ENV === "prod"){
      return process.env.COMPONENT_OVERWRITE_API_URL || "https://www.directv.com/assets/content/hddytjvubt/original/component-overwrite";
    }
    return process.env.COMPONENT_OVERWRITE_API_URL_TEST || "https://www.directv.com/assets/content/zsbgzjfude/original/component-overwrite-test";
  },
  get COMPONENT_OVERWRITE_TIMEOUT_MS() {
    return parseInt(process.env.COMPONENT_OVERWRITE_TIMEOUT_MS || "10000");
  },
  get COMPONENT_OVERWRITE_CACHE_INT() {
    return parseInt(process.env.COMPONENT_OVERWRITE_CACHE_INT || "15"); // minutes
  },
  get DTVS_EPOCH_SERVER_DATE() {
    return process.env.DTVS_EPOCH_SERVER_DATE;
  },
  get CUSTOM_SECRET_ENV() {
    return process.env.CUSTOM_SECRET_ENV;
  },
  get CACHE_KEY_PREFIX() {
    return process.env.CACHE_KEY_PREFIX;
  },
  get IS_DEV_MODE() {
    return process.env.DEV_MODE?.trim()?.toUpperCase?.() === "TRUE";
  },
  get IS_DEV_MINIMAL() {
    // Hard-block in production even if DEV_MINIMAL=true somehow leaks into a prod
    // ConfigMap — the flag skips secrets, cache, and installs a 404 catchall.
    if (process.env.NODE_ENV === "production") {
      return false;
    }
    return process.env.DEV_MINIMAL?.trim()?.toUpperCase?.() === "TRUE";
  },
  get IS_LOCAL() {
    return process.env.LOCAL?.trim()?.toUpperCase?.() === "TRUE";
  },
  get CACHE_MAX_ENTRIES() {
    const val = parseInt(process.env.CACHE_MAX_ENTRIES || "5000", 10);
    return Number.isNaN(val) || val < 1 ? 5000 : val;
  },
  get CACHE_MAX_BYTES() {
    // Byte ceiling for the in-memory fallback LRU. Count-only eviction can OOM
    // the pod heap when values are MB-scale (satellite/channel/page payloads);
    // this bounds total bytes too. Size against the pod memory limit /
    // --max-old-space-size. Default 256MB.
    const val = parseInt(process.env.CACHE_MAX_BYTES || "", 10);
    return Number.isNaN(val) || val < 1 ? 256 * 1024 * 1024 : val;
  },
  /** Server log verbosity: error | warn | info | debug. Defaults to info.
   * Per-request verbose logs are emitted at debug level and therefore
   * skipped (no JSON.stringify cost) unless UF_LOG_LEVEL=debug is set. */
  get LOG_LEVEL() {
    return (process.env.UF_LOG_LEVEL || "info").trim().toLowerCase();
  },
  get CACHE_HOST() {
    return process.env.CACHE_HOST;
  },
  get CACHE_PORT() {
    return parseInt(process.env.CACHE_PORT);
  },
  get CACHE_TLS() {
    // Enable encryption-in-transit to ElastiCache. When true, ioredis connects
    // with tls:{} (standard TLS; SNI = the node endpoint). OFF by default so the
    // current plaintext behavior is unchanged until ops opts in at cutover.
    return process.env.CACHE_TLS?.trim()?.toLowerCase() === "true";
  },
  get CACHE_PASSWORD() {
    // Optional Redis AUTH token / RBAC-user password. Loaded from AWS Secrets
    // Manager in deployed envs (mirrors CHANNELS_SERVICE_AUTH_TOKEN). Unset = no
    // AUTH sent (current behavior). Read at connect time so a secret loaded after
    // module import (loadSecretsToEnv) is still picked up.
    return process.env.CACHE_PASSWORD;
  },
  get CACHE_REQUIRE_PREFIX() {
    // When true, initRedisClient THROWS if CACHE_KEY_PREFIX is empty while the
    // Redis cluster CLIENT initializes — i.e. on every non-dev boot REGARDLESS
    // of DATA_SOURCE (deliberate: phase-1 dual-writes reach the possibly-shared
    // cluster just the same, so an unprefixed phase-1 rollout collides with /
    // can clear another tenant exactly like a redis-primary one). Set this on a
    // SHARED ElastiCache cluster. Default false (log-only), since a dedicated
    // per-env cluster needs no prefix and must not fail to boot.
    return process.env.CACHE_REQUIRE_PREFIX?.trim()?.toLowerCase() === "true";
  },
  get CACHE_EXIT_ON_UNHEALTHY_BOOT() {
    // Legacy behavior: process.exit(1) when the boot cache-health gate fails after
    // retries. Default false — do NOT crash the pod on a cold/empty/unreachable
    // Redis at cutover (that causes a correlated CrashLoopBackOff across the
    // fleet). Instead come up UNREADY: /utils/healthcheck returns 500 so the k8s
    // readiness probe holds traffic while the background refresh runner repopulates
    // and flips the health flag. Set true to restore fail-fast exit.
    return process.env.CACHE_EXIT_ON_UNHEALTHY_BOOT?.trim()?.toLowerCase() === "true";
  },
  get API_AUTH_KEY() {
    return process.env.CACHE_API_AUTH_KEY || process.env.EPOCH_ACCESS_TOKEN;
  },
  get AWS_ACCESS_KEY_ID() {
    return process.env.AWS_ACCESS_KEY_ID;
  },
  get AWS_SECRET_ACCESS_KEY() {
    return process.env.AWS_SECRET_ACCESS_KEY;
  },
  get AWS_SESSION_TOKEN() {
    return process.env.AWS_SESSION_TOKEN;
  },
  get IS_REDIS_DATA_SOURCE() {
    return process.env.DATA_SOURCE?.toLowerCase() === "redis";
  },
  get SHADOW_READ_SAMPLE_RATE() {
    const val = parseInt(process.env.SHADOW_READ_SAMPLE_RATE ?? "", 10);
    if (Number.isNaN(val)) {
      return 10;
    }
    return Math.max(0, Math.min(100, val));
  },
  // Shop epoch proxy path — used by the digital (directvOnline) offer calls.
  get EPOCH_OFFERS_PATH() {
    return process.env.EPOCH_OFFERS_PATH || '/shop/api/getOffers';
  },
  // msapi epoch (origin) path — used by the directIntegrationPartner offer call,
  // kept separate from the shop epoch proxy. Host defaults to the shared Epoch
  // host; both are env-overridable.
  get EPOCH_MSAPI_HOST() {
    return process.env.EPOCH_MSAPI_HOST || process.env.NEXT_EPOCH_HOST;
  },
  get EPOCH_MSAPI_OFFERS_PATH() {
    return process.env.EPOCH_MSAPI_OFFERS_PATH || '/msapi/epochofferms/v2/getOffers';
  },
  get START_UP_JITTER_MAX_MN() {
    return process.env.START_UP_JITTER_MAX_MN ? parseInt(process.env.START_UP_JITTER_MAX_MN) : 1; // 1 minute
  },

  // ---------------------------------------------------------------------------
  // channels-service integration (WAT-10500 / Phase 1)
  // See target/UF_INTEGRATION_PLAN.md §2.3
  // ---------------------------------------------------------------------------
  /** Mule proxy host for the channels-service (full origin + base path). */
  get MULE_HOST() {
    return process.env.MULE_HOST;
  },
  /**
   * Optional full `Authorization` header value used when calling the
   * channels-service via the Mule edge (the VPM Mule edge proxy).
   * When unset, no Authorization header is sent (suitable for in-cluster calls
   * routed via the conexus proxy, OR direct calls to the channels-service
   * cluster ingress where no auth is required).
   *
   * Convention mirrors EPOCH_ACCESS_TOKEN: the value is the FULL header
   * value, including any `Basic ` / `Bearer ` prefix. Loaded from AWS
   * Secrets Manager via `server/aws/load-secrets.ts` in deployed envs;
   * placed in `.env` for local dev.
   */
  get CHANNELS_SERVICE_AUTH_TOKEN() {
    return process.env.CHANNELS_SERVICE_AUTH_TOKEN;
  },
  /**
   * Per-env flag for the channels-service migration. Sourced from
   * `config/env-config.json` `<env>.configMap.USE_CHANNELS_SERVICE` (TRUE/FALSE
   * string, matching the existing USE_STORYBLOK / USE_AEM / USE_EVOLV
   * convention). When TRUE:
   *   - channels[] come from the channels-service (replaces flat-file channels)
   *   - chrome / CCT config come from Storyblok stories
   *     (sales/www/channel-lineup/index + sales/www/channel-lineup/modal)
   *     instead of AEM flat-files (chlupPageData.json + chlupCmprModalData.json)
   * When FALSE: existing CMS-fetched path serves channel data exactly as
   * it does today during rollout.
   */
  get USE_CHANNELS_SERVICE() {
    return process.env.USE_CHANNELS_SERVICE;
  },
  /**
   * Backend environment for the channels-service `dcp-env` routing header.
   * Decoupled from K8S_ENV_PREFIX because the channels-service backend is only
   * deployed to specific VPM envs — all non-prod points at `test1` (the single
   * deployed backend), stage → `stage2`, prod → `prod1`. Sourced per-env from
   * `config/env-config.json` <env>.configMap.CHANNELS_SERVICE_ENV (and the
   * GitOps ConfigMap). When unset, no `dcp-env` header is sent.
   */
  get CHANNELS_SERVICE_ENV() {
    return process.env.CHANNELS_SERVICE_ENV;
  }

};

export default envConstants;
